import { Injectable } from '@angular/core';
import { ContaContabil } from '../../../../types/ContaContabil.type';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ContascontabeisService {

  constructor(private configService: ConfigService, private httpClient: HttpClient) { }

  getContasContabeis() {

    return this.httpClient.get<ContaContabil[]>(`${this.configService.getApiUrlRoot()}/contascontabeis/`)

  }

  exportar(){

    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/contascontabeis/relatorios/exportar`, { responseType: 'blob'})
  }
}
